import { useFlag } from '@unleash/proxy-client-react';

// generate this list by exporting feature flags as json from unleash
// copy the json, and paste it in this snippet: (<json goes here>).features.map(({ name }) => name)
// and just copy the resulting array
const FeatureFlagNames = [
  'accessToFormativeAssessment',
  'access_to_new_novelstudies',
  'add-material-file',
  'aiDrawingFeedback',
  'ai-templates',
  'AI_TEMPLATES',
  'AI_TEMPLATES_CONSUME',
  'browse_by_standards',
  'CLASSLINK_NEW_UNIQUE_ID',
  'CL_PAGE_V2',
  'CL_SLIDES_PREVIEW',
  'CURILIVE_FORCE_RELOAD',
  'CURIPOD_OUTTAKES',
  'custom-trial-expiration-dates',
  'discover',
  'discover_admin',
  'dynamic_curify',
  'dynamic_full_lesson',
  'dynamic_lesson_prompt_updates',
  'dynamic_lesson_v2',
  'enableNewCreatePage',
  'FALL_24_CONTENT_HIERARCHY',
  'GENERATOR_PAGE_RECOMMENDATIONS',
  'google_drive_integration',
  'HOTJAR_MONITORING',
  'isAllowedToPublishGenerator',
  'isNewIAEnabled',
  'isTranslateTabEnabled',
  'IS_PRIVATE_SETTINGS',
  'IS_UNDER_MAINTENANCE',
  'isUseAttentionLock',
  'l10n-experiment',
  'localtest',
  'objective-refinement-on-landing',
  'orgPickerV2',
  'orgPickerV2districtSignupEnabled',
  'previously-uploaded-images',
  'REVERSE_TRIAL_MVP',
  'rubric-based-ai-feedback',
  'SCHOOL_USAGE',
  'showMaintananceToast',
  'single_testprep_form',
  'STUDENT_FLEXIBILITY',
  'templated_customizable_lessons',
  'tenor_gifs',
  'useAiFeedbackPrompt',
  'useAzureOpenAi',
  'useCompareAndContrastLessonFlag',
  'useCountrySchoolSelectionV2',
  'useCurimoteNavigation',
  'useGeneratorPlugin',
  'use_new_dynamic_lesson_blocks',
  'useNewParticipantsLogic',
  'useNewReportPrompt',
  'useNewResults',
  'useOpenAIIsDown',
  'usePromptResultsTesting',
  'USE_RECOMMENDED_GENERATORS',
  'useTestingGeneratorsFlag',
  'wordcloudnext',
  'show_individual_premium_unauthenticated',
  'international_individual_premium',
  'show_sample_lessons',
  'newCuriQuizFlow',
  'display_state_picker_home_internal',
  'quick-writes-filtering',
  'activity-revision-editing',
  'vocabulary_dropdown',
  'auth-errors-troubleshoot',
  'lesson-limit-system-v2',
  'can_impersonate',
  'pre_made_math_lessons',
  'spelling_practice',
  'phonics_wizard',
  'LATIN_ROOTS_WIZARD',
  'grammar_practice',
  'drag_timer',
  'TESTPREP_RUBRIC_EDITING',
  'premium-testprep-play-limit',
  'FLAT_DESIGNER_SETTINGS',
  'use_db_standards',
  // DB standards for GA, SC, NC, OH, NJ, MI, LA, NV, WA, IA, CO, TN, NY, OK, MS — create in Unleash dashboard
  'use_db_standards_more_states',
  'internal_save_generated_lessons_as_free',
  'http_detect_strengths',
  'force_open_great_picks',
  'native_retry',
] as const;

type FeatureFlagName = typeof FeatureFlagNames[number];

export function useFeatureFlag(name: FeatureFlagName): boolean {
  const isEnabled = useFlag(name);
  return isEnabled;
}
